export const importExportTemplate = (path: string) => `export * from '${path}'`
